import { useState, useEffect } from "react";
import { db } from "../firebase/config";
import { collection, query, onSnapshot, where } from "firebase/firestore";

export const useFetchDayOff = (docCollection, date = false) => {
    const [documents, setDocuments] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(null);

    useEffect(() => {
        setLoading(true);
        setError(null);

        if (!docCollection || !date) {
            setDocuments([]);
            setLoading(false);
            return;
        }

        const collectionRef = collection(db, docCollection);
        const q = query(
            collectionRef,
            where("date", "==", date)
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            setDocuments(
                querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }))
            );
            setLoading(false);
        }, (error) => {
            setError(error);
            setDocuments([]);
            setLoading(false);
        });

        return unsubscribe;

    }, [date, docCollection])

    return { documents, loading, error };
}
